/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';

import { Theme as MaterialTheme, useTheme, Paper, Stack, TextField, Button, Container, InputAdornment, IconButton } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { useState, useEffect, Dispatch, SetStateAction, } from "react";

import { useAppBarHeight, useDebounce } from '../../../common/CustomHooks';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers';
import DatagridDocuments from '../components/DatagridDocuments';
import { Close } from '@mui/icons-material';

const DocumentsMyPrevious = (): JSX.Element => {

    const { organizationId } = useParams();

    const theme = useTheme();

    const { t, i18n } = useTranslation();

    const [search, setSearch] = useState("");

    //##########################################################################################################



    //###############################################################################################################################################
    //###############################################################################################################################################
    //########################################################API Calls and useEffects###############################################################
    useEffect(() => {
        let isMounted = true; //Avoid memory leaks. Async function running after dismount.
        //const service = new SourceDocumentService();

        const getData = async () => {

        };
        //Close current window when searching for something new
        getData();

        return () => { isMounted = false };
    }, []);

    //###############################################################################################################################################
    //###############################################################################################################################################
    
    //###############################################################################################################################################
    //###############################################################################################################################################
    const appBarHeight = useAppBarHeight();
    //########################################################################################
    //########################################################################################
    return <main>
        <Grid container direction="column" wrap="nowrap"
            sx={{
                padding: theme.spacing(2),
                width: "100%",
                height: {
                    xs: "calc(100vh - " + appBarHeight + "px )",
                    xl: "calc(100vh)"
                },
                //"& .MuiDataGrid-columnHeaders": { backgroundColor: theme.palette.info.main, color: "white" },
                //"& .MuiDataGrid-footerContainer": { backgroundColor: theme.palette.info.main, color: "white" }
            }}>
            {/*<Grid container spacing={2} padding={theme.spacing(2)}>*/}

            {/*</Grid>*/}
            <Container component={Paper} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <Grid container direction="column" paddingBottom={theme.spacing(2.5)} flex="1 1 auto" minHeight="40rem">
                    <Stack direction="column" width="100%" height="100%" minHeight="40rem" paddingTop={theme.spacing(3)}>
                        <TextField size="small" variant="outlined" color="warning" value={search} sx={{ width: "16rem", alignSelf:"flex-end" }}
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end" component={IconButton} onClick={() => setSearch("")}
                                        sx={{ display: search ? "inherit" : "none" }}><Close /></InputAdornment>,
                            }}
                            onChange={(e) => setSearch(e.target.value)}
                            id="searchPendingDocuments" label={t("search.search")} />
                        <DatagridDocuments org={organizationId ? organizationId : ""} type="Mine" status={null} onlyActive={false} />
                    </Stack>
                </Grid>
            </Container>
            
        </Grid>
    </main>

}
export default DocumentsMyPrevious;